import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import sharedContent from './domain/shared.content.json';
import { ErrorPageComponent } from './application/error-page/error-page.component';
import { BetaalverzoekNavigation } from './betaalverzoek.navigation';
import { LandingPageComponent } from './application/landing-page/landing-page.component';
import { ResultPageComponent } from './application/result-page/result-page.component';
import { TransactionResultComponent } from './domain/transaction-result-component/transaction-result.component';

const prefixTitle: string = `${sharedContent['pagetitle.prefix'].default}`;
const postfixTitle: string = `${sharedContent['pagetitle.postfix'].default}`;

function getTitle(tag: string): string {
    return `${prefixTitle}${sharedContent[tag].default}${postfixTitle}`;
}

const appRoutes: Routes = [
    {
        path: BetaalverzoekNavigation.landingPageV2Path,
        component: LandingPageComponent,
        title: getTitle('betalen.betaalverzoek')
    },
    {
        path: BetaalverzoekNavigation.successReturnV2Path,
        component: ResultPageComponent,
        title: getTitle('betalen.gelukt')
    },
    {
        path: BetaalverzoekNavigation.errorPagePath,
        pathMatch: 'full',
        component: ErrorPageComponent,
        title: getTitle('betalen.mislukt')
    },
    {
        path: '**',
        redirectTo: BetaalverzoekNavigation.errorPagePath
    }
];

@NgModule({
    imports: [
        ErrorPageComponent,
        LandingPageComponent,
        TransactionResultComponent,
        ResultPageComponent,
        RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [RouterModule]
})
export class BetaalverzoekRouterModule {}
